module.exports = __webpack_public_path__ + "img/南和宠物食品.2853906f.jpg";